module.exports = __webpack_public_path__ + "img/secondary_5x2_z18.69963bbd.svg";